import React from 'react';
import {
  MenuItem,
  Typography,
  List,
  ListItemText,
  Divider,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';

export default function NotificationDropdown({ notifications, markAsRead }) {
  if (notifications.length === 0) {
    return (
      <MenuItem disabled>
        <Typography variant="body2" color="textSecondary">
          No notifications
        </Typography>
      </MenuItem>
    );
  }

  return (
    <List dense style={{ width: '100%' }}>
      {notifications.map(notif => (
        <div key={notif.id}>
          <MenuItem>
            <ListItemText
              primary={notif.title}
              primaryTypographyProps={{
                style: {
                  fontWeight: notif.read ? 'normal' : 'bold',
                },
              }}
            />
            {!notif.read && (
              <Tooltip title="Mark as read">
                <IconButton
                  size="small"
                  onClick={() => markAsRead(notif.id)}
                >
                  <DoneIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </MenuItem>
          <Divider />
        </div>
      ))}
    </List>
  );
}
